import { Component, Inject, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Planner } from '@authority-labs/api-interfaces';
import { CrudDialogComponent } from '@check-list/app/classes/crud-dialog.component';
import { PlannersService } from '../../../modules/planners/planners.service';

@Component({
  selector: 'authority-labs-planner-dialog',
  templateUrl: './create-planner-dialog.component.html',
  styleUrls: ['./create-planner-dialog.component.scss']
})
export class CreatePlannerDialogComponent extends CrudDialogComponent<Planner> {
  get title(): string {
    return this.isNew ? 'יצירת מתכנן חדש' : 'פרטי המתכנן';
  }

  constructor(
    public dialogRef: MatDialogRef<Planner>,
    @Inject(MAT_DIALOG_DATA) planner: Planner,
    plannersService: PlannersService,
    injector: Injector
  ) {
    super(dialogRef, plannersService, planner, injector);
  }
}
